import {
  Box,
  Card,
  CardContent,
  GridLegacy as Grid,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import React from 'react';
import {
  RiCustomerService2Fill,
  RiRefund2Fill,
  RiSecurePaymentFill,
} from 'react-icons/ri';
import { theme } from 'theme/theme';

import { appConfig } from '../../config/runtimeConfig';

const footerBg = (width: number) =>
  `url('https://cdn.ellipsis.sc/${width}x0/filters:format(webp)/filters:quality(75)/assets/footer-bg.jpg')`;

const PeaceOfMind = () => {
  const USPCard = styled(Card)(() => ({
    height: '100%',
  }));

  const USPCardContent = styled(CardContent)(() => ({
    display: 'flex',
    alignItems: 'stretch',
    padding: '30px !important',
  }));

  const USPIconWrapper = styled(Box)(() => ({
    maxWidth: '100px',
    color: theme.palette.primary.main,
  }));

  return (
    <Box
      sx={{
        boxSizing: 'border-box',
        // Resized WebP per breakpoint via the CDN's image handler - the
        // original is a 1920px, ~350KB JPEG, fetched even on phones.
        backgroundImage:
          appConfig.APP_BRAND === 'ellipsis'
            ? { xs: footerBg(800), md: footerBg(1600) }
            : 'none',
        boxShadow: '0 0 10px #000 inset',
        backgroundPosition: 'center center',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        width: '100%',
        overflowX: 'hidden',
      }}
    >
      <Grid
        container
        spacing={4}
        justifyContent="space-evenly" // Ensures equal spacing
        sx={{
          padding: '30px',
        }}
      >
        <Grid item xs={10} md={4}>
          <USPCard>
            <USPCardContent>
              <Grid item xs={2}>
                <USPIconWrapper>
                  <RiSecurePaymentFill size={'90%'} />
                </USPIconWrapper>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="h3" gutterBottom>
                  Secure Payments
                </Typography>
                <Typography variant="h6" component="p" gutterBottom>
                  Secure transactions with <strong>Stripe&reg;</strong>,
                  wherever you are in the world.
                </Typography>
              </Grid>
            </USPCardContent>
          </USPCard>
        </Grid>
        <Grid item xs={10} md={4}>
          <USPCard>
            <USPCardContent>
              <Grid item xs={2}>
                <USPIconWrapper>
                  <RiRefund2Fill size={'90%'} />
                </USPIconWrapper>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="h3" gutterBottom>
                  Money Back Guarantee
                </Typography>
                <Typography variant="h6" component="p" gutterBottom>
                  <strong>100% of your money refunded</strong> if you change
                  your mind within the cancellation window.
                </Typography>
              </Grid>
            </USPCardContent>
          </USPCard>
        </Grid>
        <Grid item xs={10} md={4}>
          <USPCard>
            <USPCardContent>
              <Grid item xs={2}>
                <USPIconWrapper>
                  <RiCustomerService2Fill size={'90%'} />
                </USPIconWrapper>
              </Grid>
              <Grid item xs={10}>
                <Typography variant="h3" gutterBottom>
                  Peace of Mind
                </Typography>
                <Typography variant="h6" component="p" gutterBottom>
                  <strong>Your experience matters</strong>, that's why we don't
                  pay hosts until after your booking is complete.
                </Typography>
              </Grid>
            </USPCardContent>
          </USPCard>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PeaceOfMind;
